import { Link } from "react-router-dom";
import styled from "styled-components";
import logo from "assets/images/icons/new-logo.png";
// import { ReactSVG } from "react-svg";

const LogoContainer = styled.div`
    margin-top: 5px;
    margin-bottom: 5px;
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
    color: #1c1c1c;
`;

const Logo = () => {
    return (
        <Link to={"/"} style={{ textDecoration: "none" }}>
            <LogoContainer>
                {/* <ReactSVG src={logo} /> */}
                <img src={logo} alt="404" sizes="20px" width={'100px'} style={{marginTop:"10px"}}/>
            </LogoContainer>
        </Link>
    );
};

export default Logo;
